import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { statsKeys } from '../queries/keys';
import { statsPaths } from '../queries/paths';

// TSS vite/03 — server-state de los KPIs agregados del cliente. Endpoint REAL:
// GET public/stats?view=kpi|report|full (contracts public-kpis.md /
// public-reports.md; mismo assembler que el admin, 0049). El scope es el
// client_id del TOKEN — jamás se envía desde acá.
//
// Devuelve el SOBRE público completo: el caller lee data.donors_kpi /
// data.recipients_kpi / data.report con envelopeData() y gatea cada bloque por
// envelopeModules() (módulo ausente = N/A para tu rol; presente con count 0 =
// sin datos aún). Errores → ApiError (400 {fields} si from/to inválido).
export function useClientStats(view = 'kpi', { from, to } = {}) {
    return useQuery({
        queryKey: statsKeys.view(view, { from, to }),
        queryFn: ({ signal }) =>
            api.get(statsPaths.base(), { params: { view, from, to }, signal }).then((r) => r.data),
        // Mantiene el informe actual en pantalla mientras carga el nuevo rango.
        placeholderData: keepPreviousData,
    });
}
